(function () {
  'use strict';

  var RELEASE_REPOSITORY = 'SimCoaches/TrackProV2';
  var RELEASES_API_URL =
    'https://api.github.com/repos/' + RELEASE_REPOSITORY + '/releases?per_page=12';
  var CACHE_KEY = 'trackpro_v2_release_feed';
  var CACHE_DURATION_MS = 5 * 60 * 1000;
  var releases = [];

  function readCache() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (!cached || Date.now() - cached.timestamp > CACHE_DURATION_MS) return null;
      return cached.value;
    } catch (error) {
      return null;
    }
  }

  function writeCache(value) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        timestamp: Date.now(),
        value: value
      }));
    } catch (error) {
      // Private browsing and strict storage settings must not block downloads.
    }
  }

  function requestJson(url) {
    return fetch(url, {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('release_feed_' + response.status);
      return response.json();
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatDate(dateString) {
    var date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  function formatBytes(bytes) {
    if (!bytes) return '';
    var megabytes = bytes / (1024 * 1024);
    return megabytes >= 1
      ? megabytes.toFixed(1) + ' MB'
      : Math.round(bytes / 1024) + ' KB';
  }

  function normalizeVersion(value) {
    return String(value || '').replace(/^v/i, '');
  }

  function isInstallerAsset(asset) {
    return asset && /^TrackPro_[0-9]+\.[0-9]+\.[0-9]+_x64-setup\.exe$/i.test(asset.name || '');
  }

  function installerForRelease(release) {
    if (!release || !Array.isArray(release.assets)) return null;
    return release.assets.find(isInstallerAsset) || null;
  }

  function notesHtml(notes) {
    var lines = String(notes || '')
      .split(/\r?\n/)
      .map(function (line) { return line.trim(); })
      .filter(Boolean);
    if (!lines.length) return '<p>Release notes are included with this version.</p>';

    var items = lines.filter(function (line) { return /^[-*]\s+/.test(line); });
    if (items.length) {
      return '<ul>' + items.map(function (line) {
        return '<li>' + escapeHtml(line.replace(/^[-*]\s+/, '')) + '</li>';
      }).join('') + '</ul>';
    }
    return '<p>' + lines.map(escapeHtml).join('<br>') + '</p>';
  }

  function setDownloadState(release, installer) {
    if (!release || !installer || !installer.browser_download_url) {
      throw new Error('invalid_customer_release');
    }

    var version = normalizeVersion(release.tag_name || release.name);
    document.querySelectorAll('[data-hub-version]').forEach(function (element) {
      element.textContent = 'V' + version;
    });

    document.querySelectorAll('[data-hub-download]').forEach(function (button) {
      button.href = installer.browser_download_url;
      button.setAttribute('download', '');
      button.setAttribute('aria-label', 'Download TrackPro V2 ' + version + ' for Windows');
      button.classList.remove('trackpro-hub-skeleton');
    });

    var fileInfo = document.querySelector('[data-hub-fileinfo]');
    if (fileInfo) {
      var size = formatBytes(installer.size);
      fileInfo.textContent = 'TrackPro V2 ' + version + ' • Windows 10/11 64-bit' +
        (size ? ' • ' + size : '');
    }
  }

  function renderReleases() {
    var container = document.getElementById('trackpro-releases-list');
    if (!container) return;

    var customerReleases = releases.filter(function (release) {
      return !release.draft && !release.prerelease && installerForRelease(release);
    });

    if (!customerReleases.length) {
      container.innerHTML =
        '<div class="trackpro-hub-error"><p>Release history is temporarily unavailable. ' +
        'The download button above still serves the current signed installer.</p></div>';
      return;
    }

    container.innerHTML = customerReleases.map(function (release, index) {
      var asset = installerForRelease(release);
      var version = normalizeVersion(release.tag_name || release.name);
      var size = formatBytes(asset.size);
      var latestClass = index === 0 ? ' trackpro-hub-release--latest open' : '';
      return '<article class="trackpro-hub-release' + latestClass + '" data-release>' +
        '<button type="button" class="trackpro-hub-release__header" data-release-toggle ' +
        'aria-expanded="' + (index === 0 ? 'true' : 'false') + '">' +
        '<span class="trackpro-hub-release__info">' +
        '<span class="trackpro-hub-release__version">V' + escapeHtml(version) + '</span>' +
        (index === 0 ? '<span class="trackpro-hub-release__tag">Latest</span>' : '') +
        '<span class="trackpro-hub-release__date">' + escapeHtml(formatDate(release.published_at)) + '</span>' +
        '</span>' +
        '<span class="trackpro-hub-release__toggle" aria-hidden="true">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span></button>' +
        '<div class="trackpro-hub-release__body">' +
        '<div class="trackpro-hub-release__changelog">' + notesHtml(release.body) + '</div>' +
        '<div class="trackpro-hub-release__actions">' +
        '<a href="' + escapeHtml(asset.browser_download_url) + '" download ' +
        'class="trackpro-hub-btn trackpro-hub-btn--primary">Download V' +
        escapeHtml(version) + (size ? ' • ' + escapeHtml(size) : '') + '</a>' +
        '</div></div></article>';
    }).join('');

    container.querySelectorAll('[data-release-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var card = toggle.closest('[data-release]');
        var isOpen = card.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function showFeedError() {
    var version = document.querySelector('[data-hub-version]');
    if (version) version.textContent = 'Check connection';
    var container = document.getElementById('trackpro-releases-list');
    if (container) {
      container.innerHTML =
        '<div class="trackpro-hub-error"><p>We could not check the current TrackPro V2 release. ' +
        'Refresh this page or contact support@simcoaches.com.</p></div>';
    }
  }

  function loadReleaseFeed() {
    var cached = readCache();
    if (cached && cached.latestRelease && cached.latestAsset) {
      setDownloadState(cached.latestRelease, cached.latestAsset);
    }
    if (cached && cached.releases) {
      releases = cached.releases;
      renderReleases();
    }

    requestJson(RELEASES_API_URL)
      .then(function (result) {
        releases = Array.isArray(result) ? result : [];
        var latestRelease = releases.find(function (release) {
          return !release.draft && !release.prerelease && installerForRelease(release);
        });
        var latestAsset = installerForRelease(latestRelease);
        setDownloadState(latestRelease, latestAsset);
        renderReleases();
        writeCache({ latestRelease: latestRelease, releases: releases, latestAsset: latestAsset });
      })
      .catch(function () {
        if (!cached) showFeedError();
      });
  }

  function initScrollSpy() {
    var sections = document.querySelectorAll('[data-hub-section]');
    var navLinks = document.querySelectorAll('.trackpro-hub-nav__link');
    if (!sections.length || !navLinks.length) return;

    function onScroll() {
      var scrollPosition = window.pageYOffset + 150;
      for (var index = sections.length - 1; index >= 0; index -= 1) {
        if (sections[index].offsetTop <= scrollPosition) {
          var sectionId = sections[index].getAttribute('id');
          navLinks.forEach(function (link) {
            link.classList.toggle('active', link.getAttribute('href') === '#' + sectionId);
          });
          break;
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    loadReleaseFeed();
    initScrollSpy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
